import { createContext, useContext, useEffect, useState } from "react";
import { AuthenticationAPI } from "@/library/entities/core/data/authentication";
import { BookmarkAPI } from "@/library/entities/socialize/data/socialize";

export const useUserContext = () => useContext(UserContext);

export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
  const [me, setMe] = useState(null);
  const [bookmarkList, setBookmarkList] = useState([]);

  const [followInstrumentList, setFollowInstrumentList] = useState([]);
  const [isLoadingFollowInstrumentList, setIsLoadingFollowInstrumentList] = useState(false);

  const [isAuthenticated, setIsAuthenticated] = useState(false);


  const getMe = async () => {
    return await AuthenticationAPI.getMe();

  }
  const getAndSetMe = async () => {
    const { data, response } = await getMe();
    setMe(data)
  };

  const loginWithCode = async (email, code) => {
    const { response, data } = await AuthenticationAPI.loginWithCode(email, code)
    const accessToken = data.access
    const refreshToken = data.refresh
    AuthenticationAPI.setAccessToken(accessToken)
    AuthenticationAPI.setRefreshToken(refreshToken)
    if (response.ok) {
      handleSuccessfulAuthentication()
      return { success: true, errors: {} }
    } else {
      return { success: false, errors: { ...data }, }
    }
  }

  const setInitialUserData = async () => {
    await Promise.all([
      getAndSetMe(),
      getAndSetBookmarks(),
      getAndSetFollowInstrumentList()
    ])
  }

  const initiateAuthentication = async (payload) => {
    const { response, data } = await AuthenticationAPI.authenticate(payload)
    if (response.ok) {
      handleSuccessfulAuthentication()
      return { success: true, errors: {} }
    } else {
      return { success: false, errors: { ...data }, }
    }
  }

  const logout = async () => {
    await AuthenticationAPI.logout()
    setIsAuthenticated(false)
    setMe(null)
  }

  const handleSuccessfulAuthentication = async () => {
    await setInitialUserData()
    setIsAuthenticated(true)
  }

  const getAndSetBookmarks = async () => {
    const data = await BookmarkAPI.getList()
    setBookmarkList(data)
  }

  const getAndSetFollowInstrumentList = async () => {
    setIsLoadingFollowInstrumentList(true)
    const data = await BookmarkAPI.getFollowInstrumentList()
    setFollowInstrumentList(data)
    setIsLoadingFollowInstrumentList(false)
  }

  const checkIsAuthenticated = async () => {
    try {
      const { response, data } = await AuthenticationAPI.getMe();
      if (response.ok) {
        setIsAuthenticated(true);
        setInitialUserData()
      }
    } catch (e) {
      // Do not set anything here to remove content flicker non logged in users
      // setIsAuthenticated(false);
      // setMe(null)
    }
  }


  //   const fetchMe = async (token) => {
  //     apiKit.setToken(token);
  //     const response = await userKit.getMe();
  //     if (response?.status === 200) {
  //       setMe(response.data);
  //     }
  //   };

  //   const updateMe = async (data) => {
  //     const response = await userKit.updateMe(data);
  //     if (response?.status === 200) {
  //       return response;
  //     }

  //     return response;
  //   };

  useEffect(() => {
    checkIsAuthenticated();
  }, []);

  const context = {
    // getMe,
    initiateAuthentication,
    logout,
    setInitialUserData,
    isAuthenticated,
    me,
    loginWithCode,
    bookmarkList,
    getAndSetBookmarks,

    followInstrumentList,
    getAndSetFollowInstrumentList,
    isLoadingFollowInstrumentList,
    // updateMe,
  };

  return (
    <UserContext.Provider value={context}>{children}</UserContext.Provider>
  );
};
